interface StatusNode {
  id: string;
  position: number;
  children?: StatusNode[];
}

export function sortOrdersByStatusTree<T extends { statusId: string | null; orderNumber: string }>(
  orders: T[], statuses: StatusNode[],
): T[] {
  const positions = new Map<string, number>();
  const visit = (nodes: StatusNode[]) => {
    for (const node of [...nodes].sort((a, b) => a.position - b.position)) {
      positions.set(node.id, positions.size);
      visit(node.children || []);
    }
  };
  visit(statuses);
  return [...orders].sort((a, b) => {
    const difference = (positions.get(a.statusId || '') ?? Number.MAX_SAFE_INTEGER)
      - (positions.get(b.statusId || '') ?? Number.MAX_SAFE_INTEGER);
    return difference || a.orderNumber.localeCompare(b.orderNumber, 'pl', { numeric: true });
  });
}
